// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_zut","cls2":"FeedbackPopover-cls2_HUc FeedbackPopover-cls1_zut"};